import { z } from "zod";
const caughtExceptionToolOutputSchema = z.object({
  caught_exception: z.literal(true),
  message: z.string()
});
function checkIsCaughtExceptionToolOutput(value) {
  return caughtExceptionToolOutputSchema.safeParse(value).success;
}
export {
  caughtExceptionToolOutputSchema,
  checkIsCaughtExceptionToolOutput
};
//# sourceMappingURL=caughtExceptionToolOutput.js.map
